import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Grid,
  theme,
} from "antd";
import { useTranslation } from "react-i18next";
import { useProfilePageSrv } from "./useProfilePageSrv";
import BrandColors from "@brand-colors";
import AddressVerification from "pages/AddressVerification/AddressVerification";
import useToasterMessage from "helpers/useToasterMessage";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";

const ProfilePage = () => {
  const { httpgetMember, httpgetDocument } = useProfilePageSrv();
  const [isHover, setIsHover] = useState(false);
  const [memberData, setMemberData] = useState();
  const [document, setDocument] = useState([]);
  const [showAddress, setshowAddress] = useState(false);
  const { useToken } = theme;
  const { UseToaster } = useToasterMessage();
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const uiState = useSelector((state: any) => state.portal.uiState);
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log(preferredLanguage,"preferredLanguage")
  const [isRightAlign, setIsRightAlign] = useState(false);

  useEffect(() => {    
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(preferredLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [ whitelabelConfig, preferredLanguage]);

  useEffect(() => {
    getMember();
    getDocument();
  }, []);

  const getMember = async () => {
    try {
      const res = await httpgetMember();
      setMemberData(res?.data);
    } catch (e) {
      handleErrorNavigation(e, navigate, t);
    }
  };

  const getDocument = async () => {
    try {
      const res = await httpgetDocument();
      setDocument(res?.data);
    } catch (e) {
      handleErrorNavigation(e, navigate, t);
    }
  };

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const validateAddress = () => {
    console.log("validate");
    setshowAddress(true);
  };

  const handleChildData = (dataFromChild: any) => {
    console.log("Data from child:", dataFromChild);
    UseToaster({
      type: "success",
      message: dataFromChild,
      description: "",
    });
    setshowAddress(false);
    getMember();
    console.log("Data from child:", dataFromChild);
  };

  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },
    currentdate: {
      fontWeight: 600,
      color: "#5e4ad2",
      fontSize: "18px",
    },

    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
    },
    cardbody: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#333333",
    },
    mainheader: {
      height: "80px",
      padding: "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },

    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },

    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      borderRadius: "50px",
      textTransform: "uppercase",
      fontWeight: "500",
      boxShadow: "none",
      fontSize: screens.md ? "14px" : "12px",
    },
    paragraph: {
      fontSize: screens.md ? "16px" : "14px",
      marginTop: "0",
      marginBottom: "12px",
      textAlign:  isRightAlign ? "right" : "left",
      display: "flex",
      flexDirection: isRightAlign ? "row-reverse" : "",
    },
    paragraph_address: {
      fontSize: screens.md ? "16px" : "14px",
      marginTop: "0",
      marginBottom: "12px",
      border: "1px solid #ccc",
      padding: "7px 10px",
    },
  };
  console.log("memberData", memberData);
  console.log("document", document);
  const formatDate = (dateString: any) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  return (
    <div
      className="row page-wrapper justify-content-md-center"
      data-testid="pass-page"
    >
      <div className="col-md-12 col-sm-12">
        <Card className="home-widget-card hls-container" style={{ borderRadius: "0", textAlign: "left" }}>
          {document && document[0] ? (
            <h3 style={{ fontSize: screens.md ? "20px" : "16px", marginTop: "0", marginBottom: "12px", fontWeight: "600" }}>{t("PROFILE_PAGE.MEMEBERID_TEXT")} </h3>
          ) : (
            ""
          )}
          {document && document[0] ? (
            <img src={document[0].DocumentData} alt="Base64 Image" style={{ maxWidth: "100%" }} />
          ) : (
            ""
          )}

          <h3 style={{ fontSize: screens.md ? "20px" : "16px", marginTop: "20px", marginBottom: "12px", fontWeight: "600",textAlign: isRightAlign ? "right" : "left" }}> {t("PROFILE_PAGE.MEMEBERINFO_TEXT")} </h3>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.MEMBER_NAME")}</span><span>:</span><span>{memberData?.PatientName}</span>
          </p>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.FIRST_NAME")}</span><span>:</span><span>{memberData?.FirstName}</span>
          </p>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.LAST_NAME")}</span><span>:</span><span>{memberData?.LastName}</span>
          </p>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.GENDER")}</span><span>:</span><span>{memberData?.Gender}</span>
          </p>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.BIRTH_DATE")}</span><span>:</span><span> {formatDate(memberData?.BirthDate)}</span>
          </p>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.EMAIL")}</span><span>:</span><span>{memberData?.Email}</span>
          </p>
          <p style={styles.paragraph}>
            <span>{t("PROFILE_PAGE.MOBILE_NUMBER")}</span><span>:</span><span>{memberData?.MobileNumber}</span>
          </p>

          <h3 style={{ fontSize: screens.md ? "20px" : "16px", marginTop: "20px", marginBottom: "12px", fontWeight: "600", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {t("PROFILE_PAGE.MEMEBERADDR_ADDR")}{" "}
            <Button
              onClick={(e) => validateAddress()}
              style={styles.button}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {t("PROFILE_PAGE.VALIDATE_BTN_TEXT")}
            </Button>
          </h3>

          <p style={styles.paragraph_address}>{memberData?.AddressLine1}</p>
          {memberData?.AddressLine2.length > 0 &&
            <p style={styles.paragraph_address}>{memberData?.AddressLine2}</p>
          }
          <p style={styles.paragraph_address}>{memberData?.AddressCity}</p>
          <p style={styles.paragraph_address}>{memberData?.AddressState}</p>
          <p style={styles.paragraph_address}>{memberData?.AddressPostalCode}</p>
        </Card>
        {showAddress && (
          <Card
            className="hls-container"
            title={t("PROFILE_PAGE.ADDRESS_INFORMATION")}
            style={{ marginTop: 15, textAlign: isRightAlign ? "right" :"left", marginBottom: 15, }}
          >
            <div className="card-body thank-container" style={{marginLeft:"-25px", marginTop:"-15px"}}>
              <AddressVerification onDataFromChild={handleChildData} />
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
